import { Injectable,   } from '@angular/core';
import { Observable, of } from 'rxjs';
import { finalize, map, shareReplay } from 'rxjs/operators';
import { LogicContainerFilter } from '../models/logic-container-filter.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class LayoutService extends BaseService {
  private layoutDic: Map<string, any> = new Map();
  private ongoingRequests: Map<string, Observable<any>> = new Map();

  constructor( ) {
    super( '/LayoutApi');
  }

  public getLayout(subUrl: string): Observable<any> {
    // Check if the layout is already cached
    const cachedLayout = this.layoutDic.get(subUrl);
    if (cachedLayout) {
      return of(cachedLayout);
    }

    // Check if there is an ongoing request for the same URL
    const ongoingRequest = this.ongoingRequests.get(subUrl);
    if (ongoingRequest) {
      return ongoingRequest;
    }

    // Make a new request and store the observable in the ongoingRequests map
    const requestObservable = super.request(subUrl, {}, 'get').pipe(
      map((response: any) => {
        this.layoutDic.set(subUrl, response);
        return response;
      }),
      // Ensure the request is removed from the map when it completes
      finalize(() => {
        this.ongoingRequests.delete(subUrl);
      }),
      // Share the same observable among multiple subscribers
      shareReplay(1)
    );

    this.ongoingRequests.set(subUrl, requestObservable);
    return requestObservable;
  }

  public getContainers(filter: LogicContainerFilter): Observable<any> {

      return super.request('GetContainers', filter)
      .pipe(map((response: any) => {
        return response?.containers;
      }));
  }
}
